import CenteredLayout from '@/layouts/CenteredLayout.vue';
import ObjectInfo from '@/views/Brand/Objects/Components/ObjectInfo.vue';
import ObjectMap from '@/views/Brand/Objects/Components/ObjectMap.vue';
import ImageCarousel from '@/components/ImageCarousel/ImageCarousel.vue';
import PriceBox from '@/views/Brand/Objects/Components/PriceBox.vue';
import { ObjectDetailsPlacePreview } from '@/views/Brand/Objects/_constants';
import CreateReportWithObjectButton from '@/views/Brand/Objects/_components/create-report-with-object-button/create-report-with-object-button.vue';
import { Btn, BtnTheme, BtnSize } from '@/components/Btn';
import { Icon, IconSize } from '@/components/Icon';
import { mdiTrayArrowDown } from '@mdi/js';
import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useObjects } from '@/composables';
import { useAuthUser } from '@/composables/use-auth-user';
import { getObjectAttachmentList, FileType, } from '@/api/v2/requests/files';
import { generateObjectPdf } from '@/views/Brand/Objects/_utils/generate-object-pdf';
export default defineComponent({
    components: {
        CreateReportWithObjectButton,
        PriceBox,
        CenteredLayout,
        ObjectMap,
        ObjectInfo,
        ImageCarousel,
        Btn,
        Icon,
    },
    props: {
        offerObject: {
            type: Boolean,
            default: false,
        },
        placePreview: {
            type: String,
            default: ObjectDetailsPlacePreview.POPOVER,
        },
        isModalChildren: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        async handleDownloadPdf() {
            this.isGeneratingPdf = true;
            try {
                await generateObjectPdf({
                    object: this.object,
                    translations: {
                        objectLabel: String(this.$t('object-details-view.object')).toUpperCase(),
                        details: String(this.$t('object-details-view.details')),
                        placeNumber: String(this.$t('object-details-view.place-number')),
                        coordinates: String(this.$t('object-details-view.coordinates')),
                        dimensions: String(this.$t('object-details-view.dimensions')),
                        light: String(this.$t('object-details-view.light')),
                        format: String(this.$t('object-details-view.format')),
                        material: String(this.$t('object-details-view.material')),
                        videoLink: String(this.$t('object-details-view.link')),
                        exposure: String(this.$t('object-details-view.exposure')),
                        yes: String(this.$t('object-details-view.yes')),
                        no: String(this.$t('object-details-view.no')),
                        localization: String(this.$t('object-details-view.localization')),
                        currency: String(this.$t('common.currency')),
                        created: String(this.$t('common.created')),
                        modified: String(this.$t('common.modified')),
                    },
                });
            }
            catch (error) {
                console.error('PDF generation failed:', error);
                this.$toast.error(this.$t('common.error-api'));
            }
            finally {
                this.isGeneratingPdf = false;
            }
        },
    },
    setup() {
        const { object, objectType } = useObjects();
        const { isAdmin } = useAuthUser();
        const multimediaAttachments = ref([]);
        const isLoadingAttachments = ref(false);
        const isGeneratingPdf = ref(false);
        const fetchAttachments = async (objectId) => {
            if (!objectId)
                return;
            isLoadingAttachments.value = true;
            try {
                const { nodes } = await getObjectAttachmentList({
                    objectId,
                    type: FileType.MULTIMEDIA,
                    perPage: 100,
                });
                multimediaAttachments.value = nodes;
            }
            catch (error) {
                console.error(error);
            }
            finally {
                isLoadingAttachments.value = false;
            }
        };
        watch(() => object.value?.id, (objectId) => {
            if (objectId) {
                fetchAttachments(objectId);
            }
        }, { immediate: true });
        const computedImages = computed(() => {
            const images = [];
            if (object.value?.logoUrl) {
                images.push({
                    url: object.value.logoUrl,
                    name: 'object image',
                });
            }
            if (multimediaAttachments.value?.length) {
                const attachmentImages = multimediaAttachments.value.map((file) => ({
                    url: file.url,
                    name: file.originalFileName || 'attachment',
                }));
                images.push(...attachmentImages);
            }
            return images;
        });
        return {
            object,
            objectType,
            BtnTheme,
            BtnSize,
            IconSize,
            mdiTrayArrowDown,
            computedImages,
            isLoadingAttachments,
            isGeneratingPdf,
            isAdmin,
        };
    },
});
